import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { Icon } from '@malirang/front-share';

@Component({
  selector: 'malirang-accordion',
  templateUrl: './app-accordion.component.html',
  imports: [Icon, CdkAccordionModule, CommonModule],
})
export class AppAccordionComponent {
  label = input<string>('');
}
